import { dateTimeFormatFr } from '@/utils/data/date'

export const DATA_TRACKING_EMAIL_PERSISTANCE_KEY = 'email'
export const DATA_TRACKING_EMAIL_COLUMNS = [
  {
    name: 'event',
    label: 'Événements',
    field: 'event'
  },
  {
    name: 'date',
    label: `Date`,
    field: 'date',
    sortable: true,
    classes: 'sticky',
    format: dateTimeFormatFr,
    headerClasses: 'sticky'
  },
  {
    name: 'emailSubject',
    label: 'Objet',
    field: 'emailSubject'
  },
  {
    name: 'email',
    label: 'Destinataire',
    field: 'email'
  }
]

const SENDINBLUE_EVENT_SENT = 'sent'
const SENDINBLUE_EVENT_HARD_BOUNCE = 'hard_bounce'
const SENDINBLUE_EVENT_SOFT_BOUNCE = 'soft_bounce'
const SENDINBLUE_EVENT_BLOCKED = 'blocked'
const SENDINBLUE_EVENT_SPAM = 'spam'
const SENDINBLUE_EVENT_DELIVERED = 'delivered'
const SENDINBLUE_EVENT_REQUEST = 'request'
const SENDINBLUE_EVENT_CLICK = 'click'
const SENDINBLUE_EVENT_INVALID = 'invalid'
const SENDINBLUE_EVENT_DEFERRED = 'deferred'
const SENDINBLUE_EVENT_OPENED = 'opened'
const SENDINBLUE_EVENT_UNIQUE_OPENED = 'unique_opened'

export const DATA_TRACKING_EMAIL_EVENTS = [
  {
    value: SENDINBLUE_EVENT_HARD_BOUNCE,
    label: 'Rejet définitif',
    color: 'negative'
  },
  {
    value: SENDINBLUE_EVENT_SOFT_BOUNCE,
    label: 'Rejet temporaire',
    color: 'warning'
  },
  {
    value: SENDINBLUE_EVENT_DELIVERED,
    label: 'Délivré',
    color: 'info'
  },
  {
    value: SENDINBLUE_EVENT_SPAM,
    label: 'Spam',
    color: 'negative'
  },
  {
    value: SENDINBLUE_EVENT_REQUEST,
    label: 'Soumis'
  },
  {
    value: SENDINBLUE_EVENT_SENT,
    label: 'Envoyé',
    color: 'positive'
  },
  {
    value: SENDINBLUE_EVENT_UNIQUE_OPENED,
    label: '1ère ouverture',
    color: 'info'
  },
  {
    value: SENDINBLUE_EVENT_OPENED,
    label: 'Ouvert',
    color: 'positive'
  },
  {
    value: SENDINBLUE_EVENT_CLICK,
    label: 'Cliqué',
    color: 'info'
  },
  {
    value: SENDINBLUE_EVENT_INVALID,
    label: 'Invalide',
    color: 'negative'
  },
  {
    value: SENDINBLUE_EVENT_DEFERRED,
    label: 'Différé',
    color: 'warning'
  },
  {
    value: SENDINBLUE_EVENT_BLOCKED,
    label: 'Bloqué',
    color: 'negative'
  }
]

export const DATA_TRACKING_EMAIL_INDEXED_COLUMNS = _.keyBy(DATA_TRACKING_EMAIL_COLUMNS, 'name')

export const DATA_TRACKING_EMAIL_SUPPRESSION = 'Suppression'
